import { Component, OnInit,AfterContentInit, OnChanges, ViewEncapsulation,Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatSliderChange } from '@angular/material/slider';

import { ResortApplicationConfiguration, ResortGuest } from '../../models/presentation.model';
import { ResortBookingClientBase } from '../../services/resort-booking.client';
import {  ApplicationConfiguration,Member, QueryParamService, Core } from '../../shared/core/ovs.core';
import { ResortDetail, ResortInventory, ResortBooking } from '../../models/presentation.model';
import { Animations } from '../../shared/animations/animations';
import { AllInclusiveFeeDetails } from './all-inclusive-fee-details.model';
import { ResortGuestExtension } from '../../models/browser.model';
import { ResortCheckoutLabelNames } from '../resort-checkout-label-names';
import { ResortComponent } from '../../shared/resort.component';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';
import { CheckoutPageEvents } from '../../instrumentation/resort-custom-events';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'pricing-info',
  templateUrl: './pricing-information.component.html',
  styleUrls: ['./pricing-information.component.scss'],
  animations: [ Animations.slideInOut],
  encapsulation: ViewEncapsulation.None
})
export class PricingInformationComponent extends ResortComponent implements OnInit, AfterContentInit, OnChanges  {

    @Input() resort: ResortDetail;
    @Input() inventory: ResortInventory;
    @Input() booking: ResortBooking;
    @Input() configuration: ApplicationConfiguration;
    @Input() member: Member;
    @Input() guests: ResortGuest[];
    @Input() updateTotal: number;
    @Input() checkOutForm: FormGroup;
    //Temp bindings
    @Input() allInclusiveDetails : string = '<pre><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p></pre>';
    @Output() grandTotalUpdated: EventEmitter<any> = new EventEmitter();
    public allInclusiveGuestsQty: number = 2;
    public allInclusivePriceTotal: number = 0.00;
    public isAllInclusive: boolean;

    private _insurancePrice: number = 0;
    public dbcCreditsUsed: number = 0;
    public memberHasVacationCash: boolean;
    public maxVCAvailable: number = 0;
    public vcCreditsUsed: number = 0;
    public purchaseTypeView: string = '';
    public discountPrice: number = 0;
    public percentSavings: number = 0;
    public maxDbcAvailable: number = 0;
    public allInclusiveFeeList: Array<AllInclusiveFeeDetails> =[];
    public aiFeeCalculated: boolean = false;
    public sorWeeksType: number = 5;
    public showCancellationWaiver: boolean = false;
    private _core: Core;

    // Get Display option label keys and values
    public getLabel(key: string): string {
    const contextKey = ResortCheckoutLabelNames[key];
    return Core.current.getLabel(contextKey);
    }

    handleErr(e) {
        this.mapApplicationInsightsObjects(e);
    }

    public getKey(key: string): string {
    return ResortCheckoutLabelNames[key];
    }

    public get hasCert():boolean{
        var cert:string = this.qryParamService.certnumber();
        return cert!=undefined && cert!=null && cert !="";
    }

    public get maskedCert():string{
        if(this.hasCert){
            var cert: string = this.qryParamService.certnumber();
             return cert.length>0 ? cert.substring(0, 3) + "•••••": "••••••••";
        }
        return "••••••••";
    }

    public get showVacationCash(): boolean{
      return this.configuration.HasVacationCash && this.configuration.Member.VCBalance!==0;
    }

    public get showCertRedemptionFee(): boolean{
        return this.inventory.certificateRedemptionFee > 0;
    }

    public get dbcDiscount(): number{
        return isNaN(this.booking.Discount) ? 0.0 : this.booking.Discount;
    }

    public get maxVacationCashCanBeApplied(): number{

        return this.inventory.price - this.dbcDiscount  + this.inventory.insurance > this.configuration.Member.VCBalance ?
                this.configuration.Member.VCBalance :
                this.inventory.price  - this.dbcDiscount + this.inventory.insurance;
    }

    public get vacationCashDiscount(): number{
        return isNaN(this.booking.VacationCashDiscount) ? 0 : this.booking.VacationCashDiscount;
    }

    public calculateGrandTotal():void{
        if(!this.booking) return;

        let discount: number = 0;
        let inventory = this.inventory;
        switch (this.booking.PurchaseTypeId) {
            case 15:
                if (inventory.creditsUsed) discount = inventory.creditsUsed;
                break;
            default:
                discount = inventory.savings;
                break;
        }

        this.booking.AllInclusiveFees = this.calculateAllInclusiveFee();
        this.booking.GrandTotal = inventory.priceWithTaxesAndFees + inventory.insurance - discount - (this.booking.VacationCashDiscount ? this.booking.VacationCashDiscount: 0) + inventory.certificateRedemptionFee + this.booking.AllInclusiveFees + (this.booking.IsUpgradeMembershipSelected ? this.booking.UpgradeFee : 0);
        this.grandTotalUpdated.emit(this.booking.GrandTotal);
    }

    public resortHasAllInclusiveRules():boolean{
        return this.resort.resortAllInclusiveRuleList && this.resort.resortAllInclusiveRuleList.count() > 0 ;
    }

    protected calculateAllInclusiveFee():number{
        var allInclusiveFee: number = 0;
        if (this.guests !== undefined && this.guests !== null) {
            this.allInclusiveGuestsQty = this.guests.length;
        } else {
            this.allInclusiveGuestsQty = 0;
        }

        if(this.resort.isAllInclusive){
            if(this.resort.resortAllInclusiveRuleList && this.resort.resortAllInclusiveRuleList.count() > 0 && this.guests && this.guests.count() >=1){
                this.allInclusiveFeeList = new Array<AllInclusiveFeeDetails>();
                let guestsCopy = [...this.guests];

                guestsCopy.sort((a, b) => b.age - a.age);
                for (var i = 0; i < guestsCopy.length; i++)
                {
                    var currentGuest = <ResortGuestExtension>guestsCopy[i];
                   if(currentGuest.DobDay != undefined && currentGuest.DobDay!= undefined && currentGuest.DobYear!= undefined){
                        var applicableRule = this.resort.resortAllInclusiveRuleList.where(ai => ai.hasMatch(this.booking.CheckInDate,this.inventory.unitTypeId, i+1, currentGuest.age)).firstOrDefault();
                        if(applicableRule){
                            var ruleFound: boolean = false;
                            for(var j=0; j< this.allInclusiveFeeList.length; j++){
                                if(this.allInclusiveFeeList[j].rule.equals(applicableRule)){
                                    this.allInclusiveFeeList[j].multiplier = this.allInclusiveFeeList[j].multiplier + 1;
                                    ruleFound = true;
                                    break;
                                }
                            }
                            if(!ruleFound){
                                var details = new AllInclusiveFeeDetails();
                                details.rule = applicableRule;
                                details.multiplier = 1;
                                this.allInclusiveFeeList.add(details);
                            }
                        }
                    }
                }

                for(var i=0; i< this.allInclusiveFeeList.length; i++){
                    allInclusiveFee+=(this.allInclusiveFeeList[i].rule.price * this.allInclusiveFeeList[i].multiplier * this.inventory.nights);
                    this.aiFeeCalculated = true;
                }
                
                return allInclusiveFee ;
            }
        }
        return 0;
    }
  
    constructor(
        private bookingService: ResortBookingClientBase,
        private qryParamService: QueryParamService,
        core :Core
    ) {
        super();
        this._core = core;
    }

    ngOnInit() {

        if (this.configuration.HasDbc)
                this.maxDbcAvailable = this.configuration.Member.DbcBalance > this.inventory.savings ? this.inventory.savings : this.configuration.Member.DbcBalance;
        else
            this.maxDbcAvailable = 0;

        this.maxVCAvailable = this.configuration.Member.VCBalance;
        this.booking.VacationCashDiscount = 0;
        this.inventory.creditsUsed = this.maxDbcAvailable;
        this.booking.CommissionColor = this.inventory.commissionColor;
        if(this.inventory.discountPurchaseTypeId === 15) {
            this.booking.PurchaseTypeId = this.inventory.creditsUsed > 0 ? this.inventory.discountPurchaseTypeId : this.inventory.purchaseTypeId;
        }
        else {
            this.booking.PurchaseTypeId = this.inventory.discountPurchaseTypeId > 0 ? this.inventory.discountPurchaseTypeId : this.inventory.purchaseTypeId;
        }
        this.booking.Discount = this.inventory.creditsUsed;
        switch (this.booking.PurchaseTypeId) {
            case 15:
                this.purchaseTypeView = 'dbc';
                break;
            case 1:
            case 24:
                this.purchaseTypeView = 'none';
                break;
            default:
                this.purchaseTypeView = 'standard';
                this.booking.Discount = this.inventory.savings;
                this.discountPrice = this.inventory.discountRate + this.inventory.serviceFee;
                break;
        }

        this.showCancellationWaiver = Core.current.calculateDiff(this.inventory.checkInDate) && (this.inventory.inventoryType !== this.sorWeeksType);
        this.saveBooking();

        this.checkOutForm.get('guests').valueChanges.subscribe(value => {
            if (value && value.length) {
                const guestList: ResortGuest[] = [];

                value.forEach((guestForm) => {
                    const resortGuest = Object.assign(new ResortGuest(), guestForm);
                    Object.setPrototypeOf(resortGuest, ResortGuest.prototype);
                    if (this.validateResortGuest(resortGuest)) {
                        guestList.push(resortGuest);
                    }
                });

                if (guestList && guestList.length) {
                    this.guests = guestList;
                    this.calculateGrandTotal();
                }
            }
        });
    }

    ngAfterContentInit(){
        this.calculateGrandTotal();
    }

    ngOnChanges(changes:SimpleChanges){
        for (let propName in changes) {
            if(propName ==="updateTotal")  this.calculateGrandTotal();
        }
    }

    public get SellsLandInsurance(): boolean {
        return Core.current.currentConfiguration.SellsLandInsurance;
    }

    public creditsUsedChanged(event: MatSliderChange): void
    {
        this.inventory.creditsUsed =  event.value;
        this.booking.Discount = event.value;
        if(this.configuration.HasVacationCash && this.booking.VacationCashDiscount > 0){
            if(this.booking.VacationCashDiscount > this.maxVacationCashCanBeApplied){
                this.booking.VacationCashDiscount = this.maxVacationCashCanBeApplied;
            }

        }
        this.calculateGrandTotal();
        this.saveBooking();
    }

    public vacationCashUsedChanged(event: MatSliderChange): void{
        this.booking.VacationCashDiscount = event.value;
        this.calculateGrandTotal();
        this.saveBooking();
    }

    private setInsurance(insurancePrice: number): void
    {
        this._insurancePrice = this.inventory.inventoryType === this.sorWeeksType ? 0 : insurancePrice;
        this.inventory.insurance = this.booking.HasInsurance && this.inventory.inventoryType !== this.sorWeeksType ? insurancePrice : 0;
        this.calculateGrandTotal();
    }

    public onAcceptDeclineChanged(accepted: boolean): void
    {
        this.booking.HasInsurance = accepted && this.inventory.inventoryType !== this.sorWeeksType;
        this.inventory.insurance = this.booking.HasInsurance ? this._insurancePrice : 0;
        this.calculateGrandTotal();
    }

    public saveBooking(): void{
        var self = this;
        this.bookingService.Put(this.booking, (v) => this.setInsurance(v.insurance), self.handleErr.bind(this));
    }

    public unSelectUpgradeMembership(): void{
        this.booking.IsUpgradeMembershipSelected = false;
        this.calculateGrandTotal();
    }

    public hideResortCreditMessage(): boolean {
        return this._core.currentConfiguration.HideResortCreditMessage;
    }

    private validateResortGuest(resortGuest): boolean {

        if (resortGuest.ordinal === "first" || resortGuest.ordinal === "second") {
            return true;
        } else if (resortGuest.DobMonth && resortGuest.DobDay && resortGuest.DobYear && resortGuest.FirstName && resortGuest.LastName) {
            return true;
        } else {
            return false;
        }

    }

    private mapApplicationInsightsObjects(ex) {
        const mapData = new Map();
        var resortConfig = this.configuration as ResortApplicationConfiguration;
        mapData.set("memberid", resortConfig.Member.Id);
        mapData.set("ovcpartner", resortConfig.Partner.LongName);
        mapData.set("ovcpartnerid", resortConfig.Partner.Id);
        mapData.set("memberclass", resortConfig.MemberClass);
        mapData.set("product", "Resort");
        mapData.set("errormessage", ex.message ? ex.message : "Checkout unknown exception");
        mapData.set("bookingerror", ex.message ? ex.message : "Checkout unknown exception");
        mapData.set("httperrorcode", ex.code ? ex.code : ex.status ? ex.status : '');
        mapData.set("origination", "ICE");
        let jsonObject = {};
        mapData.forEach((value, key) => {
            jsonObject[key] = value;
        });
        UserActivityLogger.logEvent(CheckoutPageEvents.PricingInformationLoadFailure, jsonObject, UserActivityLoggerOptions.AppInsightsOnly);
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/pricing-information/pricing-information.component.ts